import { NavLink, useLocation } from 'react-router-dom'
import { cn } from '../../lib/utils'

const NAV_GROUPS = [
  {
    label: 'Overview',
    items: [
      { to: '/', icon: 'ti-layout-dashboard', label: 'Dashboard', exact: true },
    ],
  },
  {
    label: 'Content',
    items: [
      { to: '/businesses', icon: 'ti-building-store', label: 'Businesses' },
      { to: '/categories', icon: 'ti-category', label: 'Categories' },
      { to: '/services', icon: 'ti-briefcase', label: 'Services' },
      { to: '/pricing', icon: 'ti-currency-dollar', label: 'Pricing' },
      { to: '/faq', icon: 'ti-help-circle', label: 'FAQ' },
      { to: '/locations', icon: 'ti-map-pin', label: 'Locations' },
    ],
  },
  {
    label: 'Management',
    items: [
      { to: '/contact', icon: 'ti-mail', label: 'Messages' },
      { to: '/users', icon: 'ti-users', label: 'Users' },
      { to: '/roles', icon: 'ti-shield-check', label: 'Roles' },
      { to: '/settings', icon: 'ti-settings', label: 'Settings' },
    ],
  },
]

export function Sidebar() {
  const location = useLocation()

  function isActive(to, exact) {
    if (exact) return location.pathname === to
    return location.pathname === to || location.pathname.startsWith(to + '/')
  }

  return (
    <aside className="w-60 flex-shrink-0 bg-slate-900 flex flex-col border-r border-slate-800">
      <div className="px-5 py-4 border-b border-slate-800">
        <img
          src="/logo.svg"
          alt="AfghanSpot"
          className="h-8 w-auto object-contain brightness-[1.15]"
        />
        <p className="text-slate-500 text-[10px] mt-1.5 font-medium tracking-wide uppercase">Admin Panel</p>
      </div>

      <nav className="flex-1 py-4 overflow-y-auto">
        {NAV_GROUPS.map(group => (
          <div key={group.label} className="mb-2">
            <p className="px-4 pb-1 pt-1 text-[10px] font-semibold tracking-widest text-slate-600 uppercase">
              {group.label}
            </p>
            {group.items.map(item => {
              const active = isActive(item.to, item.exact)
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  className={cn(
                    'flex items-center gap-3 mx-2 px-3 py-2 rounded-lg text-sm font-medium transition-all mb-0.5',
                    active
                      ? 'bg-indigo-600 text-white shadow-sm shadow-indigo-500/30'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-slate-100'
                  )}
                >
                  <i className={cn('ti', item.icon, 'text-base flex-shrink-0')} />
                  {item.label}
                </NavLink>
              )
            })}
          </div>
        ))}
      </nav>

      <div className="px-4 py-3 border-t border-slate-800">
        <p className="text-xs text-slate-700 text-center">v1.0.0</p>
      </div>
    </aside>
  )
}
